import GatewayAxiosClient from '../GatewayAxiosClient';
import type {
  BulkAssetUpload,
  BulkAssetUploadType,
  BulkProcessingUploadRow,
} from '../../../components/bulkAssetProcessing/types';
export class ImportExportService {
  public async getBulkAssetUploads(): Promise<BulkAssetUpload[]> {
    const response = await GatewayAxiosClient.get(`/import-export-proxy/api/v1/bulk-asset-upload`);
    return response.data;
  }
  public async createBulkAssetUpload(payload: Partial<BulkAssetUpload>): Promise<BulkAssetUpload> {
    const response = await GatewayAxiosClient.post(`/import-export-proxy/api/v1/bulk-asset-upload`, payload);
    return response.data;
  }
  public async getBulkAssetUploadTypes(): Promise<BulkAssetUploadType[]> {
    const response = await GatewayAxiosClient.get(`/import-export-proxy/api/v1/bulk-asset-upload/upload-type`);
    return response.data;
  }
  public async getBulkAssetUploadRows(bulkProcessingUploadId: string): Promise<BulkProcessingUploadRow[]> {
    const response = await GatewayAxiosClient.get(
      `/import-export-proxy/api/v1/bulk-asset-upload/${bulkProcessingUploadId}/rows`,
    );
    return response.data;
  }
  public async executeBulkAssetJob(bulkProcessingUploadId: string): Promise<BulkAssetUpload> {
    const response = await GatewayAxiosClient.post(
      `/import-export-proxy/api/v1/bulk-asset-upload/${bulkProcessingUploadId}/execute`,
    );
    return response.data;
  }
}
